module.exports = __webpack_public_path__ + "img/plus.20a4a528.svg";